import React from "react";
import cvData from "../data/cvData.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faLocationDot } from "@fortawesome/free-solid-svg-icons";

const Contact = () => {
  const { phone, address, email } = cvData.personalInfo;
  const whatsappNumber = phone?.replace(/\D/g, "");
  const whatsappLink = `https://wa.me/${whatsappNumber}`;

  return (
    <section
      id="contact"
      className="relative z-10 mx-auto w-full max-w-6xl px-6 py-12"
    >
      <div className="glass-panel glass-sheen p-6 md:p-10">
        <h2 className="section-title">Get In Touch</h2>
        <p className="mt-4 text-sm text-text-secondary">
          Available for remote opportunities. Reach out to discuss projects, collaborations, or opportunities.
        </p>
        <div className="mt-6 grid gap-4 text-left text-base text-text-secondary md:grid-cols-3">
          {phone && (
            <a
              href={whatsappLink}
              className="glass-card flex items-center gap-3 p-4 text-left"
              target="_blank"
              rel="noopener noreferrer"
              itemProp="contactPoint"
              itemScope
              itemType="https://schema.org/ContactPoint"
              aria-label="Chat with Deklerk Basson on WhatsApp"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
              <span>WhatsApp Me</span>
            </a>
          )}
          {email && (
            <a
              href={`mailto:${email}`}
              className="glass-card flex items-center gap-3 p-4 text-left"
              aria-label="Email Deklerk Basson"
            >
              <FontAwesomeIcon icon={faEnvelope} />
              <span>Email Me</span>
            </a>
          )}
          <address className="glass-card flex items-center gap-3 p-4 not-italic">
            <FontAwesomeIcon icon={faLocationDot} />
            <span className="text-text-secondary">{address}</span>
          </address>
        </div>
      </div>
    </section>
  );
};

export default Contact;
